import React from 'react';
import SarasTrans from '../../../library/notifications/SarasTrans';

const Welcome = () => {
    return (
        <div>
            <div><SarasTrans value = "SarasX is loading....."/></div>
        </div>
    )
}

export default Welcome;